import React from 'react';
import App from './App';
import './index.css';
import { createRoot } from 'react-dom/client';
import { installAntdStaticCompat, installKnownReact19WarningFilter } from './app-utils/antdCompat';
import reportWebVitals from './reportWebVitals';

installAntdStaticCompat();
installKnownReact19WarningFilter();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
